export const getCustomerDetails = (formAnswers) => {
  const email = formAnswers.email;
  const phone = formAnswers.phone_number;
  const firstName = formAnswers.first_name;
  const lastName = formAnswers.last_name;
  const postalCode = formAnswers.postal_code;

  return {
    email,
    firstName,
    lastName,
    phone,
    postalCode,
  };
};
